// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Part } from './part';
import { PartType } from './part-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PartPartType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Types = {
        Raw: 1,
        InProcess: 2,
        InventoryPart: 3,
        FinishedProduct: 4,
        OptionUpgrade: 5,
        Replacement: 6,
        Trailer: 7,
    };
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  partId!: number;
  partTypeId!: number;
  part!: Part;
  partType!: PartType;
}

